import queryString from 'query-string';
import {
    CXEnvironments,
    ICXEnvironment,
    TCXDomains
} from '~/types/cx-types/cx-environment.types';

export function getCXEnvironment(): ICXEnvironment {
    const { hostname, searchParams } = new URL(window.location.href);
    let hostnameToUse = hostname;
    let prefix;
    let domain;
    if (searchParams.has('cpu')) {
        hostnameToUse = searchParams.get('cpu');
        persistCpuToSessionStorage(hostnameToUse);
    } else if (searchParams.has('cpd') && searchParams.has('cpp')) {
        prefix = searchParams.get('cpp');
        domain = searchParams.get('cpd');
    }
    const existingCpu = fetchCpuFromSessionStorage();
    if (existingCpu) {
        hostnameToUse = existingCpu;
    }
    if (!prefix || !domain) {
        const parts = hostnameToUse.split('.');
        if (parts.length > 1) {
            prefix = parts.shift();
            domain = parts.join('.');
        } else {
            domain = parts.shift();
        }
    }

    return calculateCXEnvironment(domain, prefix);
}

export function calculateCXEnvironment(
    domain: TCXDomains,
    prefix: string
): ICXEnvironment {
    const environment = getEnvironmentByDomain(domain, prefix);
    return {
        domain,
        prefix,
        environment,
        awsBucket:
            environment === CXEnvironments.Production
                ? 'hb-client-portal'
                : 'hb-staging-us-east-1-hb-client-portal-dev'
    };
}

function getEnvironmentByDomain(
    domain: TCXDomains,
    prefix: string
): CXEnvironments {
    if (prefix === 'staging-qa-app' && domain === 'honeybook.com') {
        return CXEnvironments.Staging;
    }

    // e2e env
    if (
        /^hb-app-staging-.+$/.test(domain) ||
        /^hb-mx-staging-.+$/.test(domain)
    ) {
        return CXEnvironments.Staging;
    }

    switch (domain) {
        case 'hbportal.co':
            return CXEnvironments.Production;
        case 'web.e2e.stg-us-east-1-v7.hbdev.io':
        case 'web.preview.stg-us-east-1-v7.hbdev.io':
        case 'api.e2e.stg-us-east-1-v7.hbdev.io':
        case 'api.preview.stg-us-east-1-v7.hbdev.io':
        case 'ws.e2e.stg-us-east-1-v7.hbdev.io':
        case 'ws.preview.stg-us-east-1-v7.hbdev.io':
        case 'e2e.hbdev.io':
        case 'stg.hbdev.io':
        case 'hb-site-dev.com':
            return CXEnvironments.Staging;
        case 'localhost':
        case 'localhost:3000':
        case 'lvh.me':
        case 'ngrok-free.app':
        case 'ngrok.app':
            return CXEnvironments.Development;
        default:
            return getEnvironmentFromUrl();
    }
}

function getEnvironmentFromUrl() {
    const { env } = queryString.parse(window.location.search);

    return env === CXEnvironments.Staging
        ? CXEnvironments.Staging
        : CXEnvironments.Production;
}

function persistCpuToSessionStorage(cpu): void {
    sessionStorage.setItem('cpu', cpu);
}

function fetchCpuFromSessionStorage(): string | null {
    return sessionStorage.getItem('cpu');
}
